import {
  FunnelTypeDescriptionEnum,
  FunnelTypeTitleEnum,
} from 'modules/funnels/enums/funnel-type-enum'
import { FunnelCreateInterface } from 'modules/funnels/types/funnel-interface'
import React from 'react'
import {
  FieldErrorAndDescription,
  FieldErrorAndDescriptionProps,
} from 'shared/components/form/field-error-and-description'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { FunnelIcon, SocialCommunityIcon, StoreIcon, SupportIcon } from '@systemeio/ui'

interface FunnelGoalSelectorProps extends FieldErrorAndDescriptionProps {
  value: FunnelCreateInterface['type']
  onChange: (value: FunnelCreateInterface['type']) => void
}

const FunnelGoalSelector = ({ value, onChange, error }: FunnelGoalSelectorProps) => {
  const { t } = useLocoTranslation()
  return (
    <div className={`flex flex-col gap-1`} data-test="funnel-goal-selector">
      <div className="flex gap-0.5">
        <span>{t('dashboard.funnel.choose_funnel_goal')}</span>
        <span className="text-danger">*</span>
      </div>
      <ul className={`flex flex-col flex-wrap gap-3 lg:flex-row`}>
        {Object.keys(FunnelTypeTitleEnum).map(el => {
          const key = el as keyof typeof FunnelTypeTitleEnum
          const isSelected = value === key
          return (
            <li key={key}>
              <button
                onClick={e => {
                  e.preventDefault()
                  onChange(key)
                }}
                className={`h-full w-full items-start rounded-lg border lg:w-[290px] ${
                  isSelected ? 'border-brand-primary' : 'border-text-secondary/50'
                } focus-visible:border-brand-primary main-transition-colors hover:border-brand-primary flex flex-col gap-1 px-4 py-4 outline-hidden`}
                data-test={`funnel-goal-${key}`}
              >
                {key === 'optin' && (
                  <SocialCommunityIcon
                    className={`${
                      isSelected && 'fill-brand-primary'
                    } main-transition-colors h-[30px]`}
                  />
                )}
                {key === 'sales' && (
                  <StoreIcon
                    className={`${
                      isSelected && 'fill-brand-primary main-transition-colors'
                    } h-[30px]`}
                  />
                )}
                {key === 'custom' && (
                  <FunnelIcon
                    className={`${
                      isSelected && 'fill-brand-primary main-transition-colors'
                    } h-[30px]`}
                  />
                )}
                {key === 'webinar' && (
                  <SupportIcon
                    className={`${
                      isSelected && 'fill-brand-primary main-transition-colors'
                    } h-[30px]`}
                  />
                )}
                <span className={'text-text-primary text-start font-bold'}>
                  {t(FunnelTypeTitleEnum[key])}
                </span>
                <span className={'text-start'}>{t(FunnelTypeDescriptionEnum[key])}</span>
              </button>
            </li>
          )
        })}
      </ul>
      <FieldErrorAndDescription error={error} />
    </div>
  )
}

export default FunnelGoalSelector
